<template>
  <div
    class="text-center"
    style="display: none"
  >
    <v-dialog
      v-model="dialog"
      persistent
      attach=".map"
      width="500"
      @click:outside="$emit('hideLegend')"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >{{ $i18n.t('dashboard.map.legend') }}</v-card-title>

        <v-card-text>
          <v-list>
            <v-list-group no-action>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    class="text--capitalize"
                  >{{ $i18n.t('dashboard.map.baselayers') }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- Base layers -->
              <v-list-item class="pl-4">
                <template>
                  <v-list-item-action>
                    <v-radio-group v-model="currentBasemap">
                      <v-radio
                        label="Mapbox Light"
                        value="MapboxLight"
                        color="primary"
                      />
                      <v-radio
                        label="Mapbox Satellite"
                        value="MapboxSatellite"
                        color="primary"
                      />
                      <v-radio
                        label="Mapbox Hybrid"
                        value="MapboxHybrid"
                        color="primary"
                      />
                      <v-radio
                        label="HERE Streets"
                        value="HereStreets"
                        color="primary"
                      />
                      <v-radio
                        label="HERE Satellite"
                        value="HereSatellite"
                        color="primary"
                      />
                      <v-radio
                        label="HERE Hybrid"
                        value="HereHybrid"
                        color="primary"
                      />
                    </v-radio-group>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-group>
            <template v-if="!isPresentation">
              <!-- WMS layers -->
              <v-list-group
                no-action
                v-if="wmsLayers.length > 0"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="text--capitalize">
                      <v-badge>
                        <template v-slot:badge>{{ wmsLayersList.length }}</template>
                        <span style="padding-right:5px;">
                          {{
                          $i18n.t('dashboard.map.wmslayers')
                          }}
                        </span>
                      </v-badge>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-icon
                    color="primary"
                    class="mr-2"
                    @click.stop="checkAll('wmsLayers')"
                    :title="selectedWMSLayers.length===wmsLayersList.length?$i18n.t('dashboard.map.deselectwmslayers'):$i18n.t('dashboard.map.selectwmslayers')"
                  >{{selectedWMSLayers.length===wmsLayersList.length?'mdi-minus-box':'mdi-checkbox-multiple-marked'}}</v-icon>
                </template>

                <v-list-item
                  class="pl-4"
                  v-for="wmsLayer in wmsLayersList"
                  :key="wmsLayer.id"
                >
                  <template>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectedWMSLayers"
                        :value="wmsLayer"
                        :label="$i18n.locale == 'pl' ? wmsLayer.name_pl : wmsLayer.name_en"
                        @change="toggleWMS(wmsLayer)"
                      />
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list-group>
              <!--User layers -->
              <v-list-group
                no-action
                v-if="userLayers.length > 0 && isDashboard"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="text--capitalize">
                      <v-badge>
                        <template v-slot:badge>{{ userLayers.length }}</template>
                        <span style="padding-right:5px;">
                          {{
                          $i18n.t('dashboard.map.userlayers')
                          }}
                        </span>
                      </v-badge>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-icon
                    color="primary"
                    class="mr-2"
                    @click.stop="checkAll('userLayers')"
                    :title="selectedUsersLayers.length===userLayers.length?$i18n.t('dashboard.map.deselectuserlayers'):$i18n.t('dashboard.map.selectuserlayers')"
                  >{{selectedUsersLayers.length===userLayers.length?'mdi-minus-box':'mdi-checkbox-multiple-marked'}}</v-icon>
                </template>

                <v-list-item
                  class="pl-4"
                  v-for="userLayer in userLayers"
                  :key="userLayer.id"
                >
                  <template>
                    <v-list-item-action>
                      <v-checkbox
                        :disabled="userLayerToEdit === userLayer.name_pl"
                        v-model="selectedUsersLayers"
                        :value="userLayer"
                        :label="$i18n.locale == 'pl' ? userLayer.name_pl : userLayer.name_en"
                        @change="toggleUserLayer(userLayer)"
                      />
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list-group>
              <!-- Edit layer -->
              <v-list-group
                no-action
                v-if="userLayers.length > 0 && isDashboard"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="text--capitalize">
                      {{
                      $i18n.t('dashboard.map.layerToEdit')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template>
                  <v-list-item-action>
                    <v-col class="pl-6">
                      <v-select
                        :attach="true"
                        outlined
                        :disabled="isUserLayerEditing"
                        clearable
                        v-model="userLayerToEdit"
                        :items="selectedUsersLayers"
                        :item-text="$i18n.locale == 'pl' ? 'name_pl' : 'name_en'"
                        @change="editLayer"
                        no-data-text="Brak wybranych warstw użytkownika"
                        :placeholder="$i18n.t('dashboard.map.layerEditingOff')"
                      />
                    </v-col>
                  </v-list-item-action>
                </template>
              </v-list-group>
            </template>
          </v-list>
        </v-card-text>

        <v-divider />

        <slot name="buttons" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    projectactive: {
      type: Boolean
    },
    isDashboard: {
      default: false,
      type: Boolean
    },
    isPresentation: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    baselayer: '',
    selectedWMSLayers: [],
    selectedUsersLayers: [],
    userLayerToEdit: undefined,
    isUserLayerEditing: false
  }),
  computed: {
    currentBasemap: {
      get() {
        return this.$store.getters.getCurrentBasemap;
      },
      set(nV) {
        this.$store.commit('setCurrentBasemap', nV);
      }
    },
    layersGroups() {
      return this.$store.getters.getLayersGroups;
    },
    notAssignedWmsLayers() {
      const notAssignedWmsLayers = [];
      for (const wmsLayer of this.wmsLayers) {
        if (this.layersGroups.find(group => group.layers && group.layers.includes(wmsLayer.id))) {
          continue;
        }
        notAssignedWmsLayers.push(wmsLayer);
      }
      return notAssignedWmsLayers;
    },
    userLayers() {
      return this.$store.getters.getUserLayersList;
    },
    wmsLayers() {
      return this.$store.getters.getWMSLayers;
    },
    wmsLayersList() {
      return this.layersGroups.concat(this.notAssignedWmsLayers);
    }
  },
  methods: {
    checkAll(checkedType) {
      if (checkedType === 'userLayers') {
        if (this.selectedUsersLayers.length === this.userLayers.length) {
          let selected = null;
          for (let selectedUserLayer of this.selectedUsersLayers) {
            if (selectedUserLayer.name_pl !== this.userLayerToEdit) {
              this.toggleUserLayer(selectedUserLayer);
            } else {
              selected = selectedUserLayer;
            }
          }
          this.selectedUsersLayers = this.userLayerToEdit ? [selected] : [];
        } else {
          let layersToToggle = this.userLayers.filter(
            x => !this.selectedUsersLayers.includes(x)
          );
          for (let selectedUserLayer of layersToToggle) {
            this.toggleUserLayer(selectedUserLayer);
          }
          this.selectedUsersLayers = this.userLayers;
        }
      } else {
        if (this.selectedWMSLayers.length === this.wmsLayersList.length) {
          for (let selectedWMSLayer of this.selectedWMSLayers) {
            this.toggleWMS(selectedWMSLayer);
          }
          this.selectedWMSLayers = [];
        } else {
          let layersToToggle = this.wmsLayersList.filter(
            x => !this.selectedWMSLayers.includes(x)
          );
          for (const selectedWMSLayer of layersToToggle) {
            this.toggleWMS(selectedWMSLayer);
          }
          this.selectedWMSLayers = this.wmsLayersList;
        }
      }
    },
    editLayer() {
      if (this.userLayerToEdit) {
        this.$store.commit('setEditingLayer', this.userLayerToEdit);
      } else {
        this.$store.commit('setEditingLayer', undefined);
      }
    },
    toggleUserLayer(val) {
      this.$emit('toggleUserLayer', val.name_pl);
    },
    toggleWMS(val) {
      if (val.layer_type) {
        this.$emit('toggleWMS', val.name_pl);
      } else {
        for (const layer of val.layers) {
          this.$emit('toggleWMS', this.wmsLayers.find(wmsLayer => wmsLayer.id === layer).name_pl);
        }
      }
    },
    userLayerEditing() {
      if (this.isUserLayerEditing) {
        this.isUserLayerEditing = false;
      } else {
        this.isUserLayerEditing = true;
      }
    }
  },
  mounted() {
    this.$root.$off('userLayerEditing');
    this.$root.$on('userLayerEditing', this.userLayerEditing);
    for (const wms of this.wmsLayersList) {
      if (wms && wms.wms_url === 'https://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaEwidencjiGruntow') {
        this.selectedWMSLayers.push(wms);
        this.toggleWMS(wms);
      }
    }
  }
};
</script>

<style lang="scss">
.text--capitalize {
  text-transform: uppercase;
}
div.v-list-item__icon.v-list-group__header__append-icon {
  margin-left: 10px !important;
  min-width: 12px !important;
}
.v-label {
  left: 10px !important;
}
.wms-list__item {
  margin-left: 15px;
  max-height: 20px;
}
</style>
